import getWithToken from './base/get-with-token'

const getDataUsageAlert = (searchData) => getWithToken(`/dashboard/usage-alert`)(searchData)

export default getDataUsageAlert